import { render, staticRenderFns } from "./tab6.vue?vue&type=template&id=6b17f7d9&"
import script from "./tab6.vue?vue&type=script&lang=js&"
export * from "./tab6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports